import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplaySecurityStatistics } from "../../../data/reports/securityStatistics/hooks/useDisplaySecurityStatistics";

export interface DisplaySecurityStatisticsProps {
  symbol?: string;
}

export const DisplaySecurityStatistics: React.FunctionComponent<DisplaySecurityStatisticsProps> = ({
  symbol,
}) => {
	  const statistics = useDisplaySecurityStatistics(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4,getPercentString } = React.useContext(
		LocalizationContext
	);

	console.log(statistics)

	const [auth] = useAuth();

	return (
		<div className={style.root}>

			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("sharesOutstanding")}</span>
				<span className={style.value}> {getFormatedNumberString(statistics?.shares_outstanding)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("avg90Volume")}</span>
				<span className={style.value}> {getFormatedNumberString(statistics?.avg_90_volume)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("shortRatio")}</span>
				<span className={style.value}> {getFormatedNumberString4(statistics?.short_ratio, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("shortPercentOfSharesOutstanding")}</span>
				<span className={style.value}> {getPercentString(statistics?.short_percent_of_shares_outstanding,false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("percentHeldByInstitutions")}</span>
				<span className={style.value}> {getPercentString(statistics?.percent_held_by_institutions, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("fiftyTwoWeekHigh")}</span>
				<span className={style.value}> {getFormatedNumberString4(statistics?.fifty_two_week_high, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("fiftyTwoWeekLow")}</span>
				<span className={style.value}> {getFormatedNumberString4(statistics?.fifty_two_week_low, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("day50Ma")}</span>
				<span className={style.value}> {getFormatedNumberString4(statistics?.day_50_ma, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("day200Ma")}</span>
				<span className={style.value}> {getFormatedNumberString4(statistics?.day_200_ma, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("beta")}</span>
				<span className={style.value}> {getFormatedNumberString4(statistics?.beta, true)}</span>
			</div>
		</div>
	);
};

